export const getLowerQualityStream = (
  url: string,
  suffix = "_240p",
): string => {
  const i = url.indexOf(".mp4")

  return url.slice(0, i) + suffix + url.slice(i)
}
